/**
 * AboutSection — the description/synopsis, clamped with a "Read more"
 * toggle so a long Open Library description never dominates the page.
 * Renders nothing at all when the resolved book has no description, rather
 * than an empty "About this book" shell.
 */

import React, { useState } from 'react';
import { Button } from '@/components/site/primitives';

export default function AboutSection({ description }) {
  const [expanded, setExpanded] = useState(false);
  if (!description) return null;

  return (
    <section className="u-container mt-10 md:mt-14" data-testid="book-details-about">
      <div className="card-paper p-5 sm:p-6">
        <h2 className="font-display text-lg font-semibold text-ink">About this book</h2>
        <p className={expanded ? 'mt-3 text-sm leading-relaxed text-ink/80' : 'mt-3 line-clamp-6 text-sm leading-relaxed text-ink/80'}>
          {description}
        </p>
        {description.length > 320 && (
          <Button variant="ghost" icon={false} onClick={() => setExpanded((e) => !e)} className="mt-2 px-0 text-xs font-semibold">
            {expanded ? 'Show less' : 'Read more'}
          </Button>
        )}
      </div>
    </section>
  );
}
